var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAngleRightB = function SvgAngleRightB(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.203 8.42 7.43 4.653a.667.667 0 1 0-.947.94l3.3 3.333-3.3 3.3a.667.667 0 0 0 .217 1.088.67.67 0 0 0 .513 0 .7.7 0 0 0 .217-.148L11.203 9.4a.666.666 0 0 0 0-.98"
  })));
};
export default SvgAngleRightB;